<template>
  <div>
    <router-link :to="url" v-if="!externalLink">
      <div class="favorite-card">
        <div class="favorite-card__body">
          <slot/>
        </div>
        <div class="favorite-card__footer">
          <i class="fa fa-heart"/> Favorited {{ savedTimeAgo }}
        </div>
      </div>
    </router-link>
    <a :href="url" v-if="externalLink">
      <div class="favorite-card">
        <div class="favorite-card__body">
          <slot/>
        </div>
        <div class="card-footer">
          <i class="fa fa-heart"/> Favorited {{ savedTimeAgo }}
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { savedWhen } from '@/util/time'

export default {
  name: 'FavoriteCard',
  data() {
    return {}
  },
  props: {
    url: {
      type: [String, Object],
      required: true,
      validate: function(value) {
        if (typeof value !== 'string' && value.keys !== undefined) {
          let fields = value.keys()
          if (fields.indexOf('name') < 0 || fields.indexOf('params') < 0) {
            return false
          }
        }
        return true
      }
    },
    savedTime: {
      type: String,
      required: true
    },
    externalLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    savedTimeAgo() {
      return savedWhen(this.savedTime)
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/mixins.less';

.fa-heart {
  color: #b71429;
}
.favorite-card {
  .paper-card;
  position: relative;
  background-color: #fafafa;
  margin-bottom: 15px;

  &:hover {
    background-color: #fffddd;
  }
}
a {
  text-decoration: none;
  color: inherit;
  display: block;
  &:hover,
  &:focus {
    text-decoration: none;
    color: inherit;
  }
}
.favorite-card__body {
}
.favorite-card__footer {
  // I intended to replace this with the card-footer style in mixins.less, but anchor page cards footer get weird without it, so I'm leaving it in
  background-color: rgba(0, 0, 0, 0.05);
  padding: 8px 16px;
  font-size: 12px;
  line-height: 20px;
  border: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
</style>
